import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';
import { AuthService } from '@auth/auth.service';

// Configs
import { HEADER_ROUTES_CONSTANTS } from '@home/header/configs';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss'],
})
export class ReferralsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('referralsRef', { static: false }) public referralsComponent: ElementRef;

  public isLoading: boolean;
  public HEADER_ROUTES_CONSTANTS: typeof HEADER_ROUTES_CONSTANTS;
  private readonly unSubscribe$: Subject<void>;

  constructor(private readonly webComponentService: WebcomponentsService, private readonly authService: AuthService) {
    this.isLoading = false;
    this.HEADER_ROUTES_CONSTANTS = HEADER_ROUTES_CONSTANTS;
    this.unSubscribe$ = new Subject<void>();
  }

  public ngAfterViewInit(): void {
    this.renderReferralsWebComponent();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderReferralsWebComponent(): void {
    const referrals = this.referralsComponent.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          referrals.ngElementStrategy?.componentRef?.instance?.build({ email: this.getLocalEmail() });
        }
      },
    });
  }

  public getLocalEmail(): string {
    return this.authService.user.email;
  }
}
